import React from 'react';
import { makeStyles, Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import FlagstoneTheme from '../../Config/flagstoneTheme';

export default function ScaleTile(props) {
    const classes = useStyles();
    const { t } = useTranslation();

    let lineNumbers = ""
    
    switch (props.scale)
    {
    case 1:
        lineNumbers = "11 - 12";
        break;
    case 2:
        lineNumbers = "14";
        break;
    case 3: 
        lineNumbers = "15 - 16";
        break;
    case 4: 
        lineNumbers = "17 - 18";
        break;
    case 5: 
        lineNumbers = "41 - 42";
        break;
    default: 

    }

    return (
        <div className={classes.scale}>
            <div className={classes.line}>
                {t("Line")}
            </div>
            <div className={classes.lineId}>
                <b>{lineNumbers}</b>
            </div>
            <div className={classes.line}>
                {t("Scale")}
            </div>
            <div className={classes.lineId}>
                <b>{props.scale}</b>
            </div>
            <div className={classes.lineId}>
                <img className={classes.scaleImage} src={process.env.PUBLIC_URL + '/img/weegschaal.jpg'}></img>
            </div>
            
            <Button onClick={() => props.ClickTile(props.scale)} className={classes.restartButton}>{t('RestartScale')}</Button>
        </div>
    )
}

const useStyles = makeStyles(() => ({
    scale: {
        backgroundColor: "white",
        borderRadius: "6px",
        padding: "20px",
        display: "flex",
        flexDirection: "column"
    },
    line: {
        color: "#8D8D8D",
        fontSize: "15px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        paddingTop: "25px",
        paddingBottom: "5px"

    },
    lineId: {
        color: "#000000",
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        paddingBottom: "10px"
    },
    restartButton: {
        backgroundColor: FlagstoneTheme.palette.primary.main,
        width: "200px",
        height: "40px",
        color: "white",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        "&:hover": {
            background: FlagstoneTheme.palette.primary.main
        },
    },
    scaleImage: {
        width: "120px",
        height: "120px"
    }
}));